import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import FadeIn from "react-fade-in";
import Popup from "./Popup";

export default function Home() {
  return (
    <FadeIn>
      <div className="homeContainer">
       <Popup />
        <h1 className="font-bold text-4xl mt-4 mb-8">Welcome to our gallery</h1>
        <h4>They say a picture is worth a thousand words, so hopefully these pictures will tell our story.</h4>
        <Link to="/gallery">
          <img src="/Images/camera.png" alt="camera" className="homePic" />
        </Link>
      </div>
    </FadeIn>
  );
}
